<div fxLayout="column" class="cipo--height--full">
    <div fxFlex="none" fxLayout.lt-lg="column" fxLayoutGap="24px" fxLayoutAlign.gt-md="space-between center">
        <h4 fxFlex="none" data-testid="complex-conditions-list-title">
            {{
                (isTransitionCondition()
                    ? "complexConditions.transitionCondition.transitionConditions"
                    : "complexConditions.conditionalPrintout.conditionalsPrintout"
                ) | translate
            }}
        </h4>
        <div fxFlex="grow" fxLayout.lt-lg="column" fxLayoutAlign.gt-md="end center" fxLayoutGap="16px">
            <div fxFlex.gt-md="none" fxLayout fxLayoutGap="16px" fxLayoutAlign.lt-lg="space-between">
                <button
                    data-testid="complex-conditions-list-add-button"
                    mat-raised-button
                    color="primary"
                    [title]="'actions.addNew' | translate"
                    (click)="addEditComplexCondition()">
                    <mat-icon aria-hidden="true">add</mat-icon>
                    {{ "actions.addNew" | translate }}
                </button>
            </div>
        </div>
    </div>

    <div fxFlex>
        @if (loading()) {
            <div class="m-t-xl">
                @for (item of skeleton(); track $index) {
                    <ngx-skeleton-loader
                        [theme]="{
                            width: '98%',
                            height: '20px',
                            marginRight: '10px',
                            marginTop: '10px',
                            marginBottom: '10px',
                        }" />
                }
            </div>
        } @else {
            @if (complexConditions()?.length) {
                <mat-list
                    data-testid="complex-conditions-list-elements"
                    class="cipo--height--full cipo--overflow--auto"
                    role="list"
                    cdkDropList
                    (cdkDropListDropped)="dropEvent($event)">
                    @for (cond of complexConditions(); track $index) {
                        @if ($index > 0) {
                            <mat-divider></mat-divider>
                        }
                        <mat-list-item role="listitem" cdkDrag>
                            <span fxLayoutAlign="space-between center" fxLayoutGap="8px" class="list-item-content">
                                <span
                                    data-testid="complex-conditions-list-condition-item"
                                    class="cipo--overflow--hidden"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxLayoutGap="8px">
                                    <ng-container
                                        [ngTemplateOutlet]="conditionsTemplate"
                                        [ngTemplateOutletContext]="{ cond: cond }"></ng-container>
                                    ,
                                    <ng-container
                                        [ngTemplateOutlet]="conditionOutputTemplate"
                                        [ngTemplateOutletContext]="{ cond: cond }"></ng-container>
                                </span>
                                <span
                                    fxLayout="row"
                                    fxLayoutAlign="end center"
                                    fxLayoutGap="8px"
                                    class="action-buttons">
                                    <button
                                        data-testid="complex-conditions-list-edit-button"
                                        mat-button
                                        class="m-r-sm"
                                        (click)="addEditComplexCondition(cond)">
                                        {{ "general.table.edit" | translate }}
                                        <mat-icon class="m-t-xs">edit</mat-icon>
                                    </button>
                                    <button
                                        data-testid="complex-conditions-list-delete-button"
                                        mat-button
                                        (click)="deleteComplexCondition(cond)">
                                        {{ "general.table.delete" | translate }}
                                        <mat-icon class="m-t-xs">delete</mat-icon>
                                    </button>
                                </span>
                            </span>
                        </mat-list-item>
                    }
                </mat-list>
            } @else {
                <span class="m-t-xl">{{ "lists.noItems" | translate }}</span>
            }
        }
    </div>
</div>

<ng-template #conditionsTemplate let-cond="cond">
    {{ "complexConditions.general.if" | translate }}

    @for (fc of cond.fieldConditions; track fc) {
        {{ fc.fieldLabel }}
        {{ "complexConditions.operators." + OperatorTypeEnum[fc.operatorId] | translate }}

        @if (fc.operatorId === OperatorTypeEnum.Between) {
            {{ fc.value }} {{ "complexConditions.general.and" | translate }} {{ fc.value2 }}
        } @else {
            {{ fc.value }}
        }

        @if (cond.fieldConditions.indexOf(fc) < cond.fieldConditions.length - 1) {
            , {{ "complexConditions.general.andIf" | translate }}
        }
    }

    @if (cond.fieldConditions?.length > 0 && cond.screenConditions?.length > 0) {
        , {{ "complexConditions.general.andIf" | translate }}
    }

    @for (sc of cond.screenConditions; track sc) {
        {{ "complexConditions.general.startScreen" | translate }}
        {{ "complexConditions.operators." + OperatorTypeEnum[sc.operatorId] | translate }}

        @if (sc.operatorId === OperatorTypeEnum.Between) {
            {{ sc.value }} {{ "complexConditions.general.and" | translate }} {{ sc.value2 }}
        } @else {
            {{ sc.value }}
        }

        @if (cond.screenConditions.indexOf(sc) < cond.screenConditions.length - 1) {
            , {{ "complexConditions.general.andIf" | translate }}
        }
    }
</ng-template>

<ng-template #valueTemplate let-cond="cond">
    @for (fc of cond.fieldConditions; track fc) {
        @if (fc.operatorId === OperatorTypeEnum.Between) {
            {{ fc.value }} {{ "complexConditions.general.and" | translate }} {{ fc.value2 }}
        } @else {
            {{ fc.value }}
        }
    }
</ng-template>

<ng-template #conditionOutputTemplate let-cond="cond">
    {{ "complexConditions.general.then" | translate }}
    @if (isTransitionCondition()) {
        {{ "complexConditions.transitionCondition.transtionToState" | translate }}
        {{ cond.stateLabel }}
    } @else {
        {{ "complexConditions.conditionalPrintout.toPrintout" | translate }}
        {{ cond.printLabel }}
    }
</ng-template>
